import { createPlugin } from "@fullcalendar/core";
import { NamedTimeZoneImpl } from "@fullcalendar/core/internal";
import { formatInTimeZone, fromZonedTime } from "date-fns-tz";

// FullCalendar needs an implementation for named zones; otherwise it uses UTC coercion.
export class CalendarTimeZone extends NamedTimeZoneImpl {
  timestampToArray(ms: number): number[] {
    const parts = formatInTimeZone(ms, this.timeZoneName, "yyyy M d H m s SSS")
      .split(" ")
      .map(Number);
    parts[1] -= 1;
    return parts;
  }

  offsetForArray(parts: number[]): number {
    const wallTime = new Date(
      Date.UTC(
        parts[0],
        parts[1],
        parts[2],
        parts[3] ?? 0,
        parts[4] ?? 0,
        parts[5] ?? 0,
        parts[6] ?? 0
      )
    );
    const instant = fromZonedTime(wallTime.toISOString().slice(0, -1), this.timeZoneName);
    return (wallTime.getTime() - instant.getTime()) / 60_000;
  }
}

export default createPlugin({
  name: "calendar-timezone",
  namedTimeZonedImpl: CalendarTimeZone,
});
